import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory } from "react-router-dom"
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//Verification code package
import AuthCode from "react-auth-code-input"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import { Button } from "@material-ui/core"

const Verification = props => {
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [otpGet, setOtpGet] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [seconds, setSeconds] = React.useState(30)
  const [resendEnabled, setResendEnabled] = React.useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("OTP")) {
      const obj = JSON.parse(localStorage.getItem("OTP"))
      console.log(obj)
      setOtpGet(obj.otp)
    }

    if (localStorage.getItem("phoneNumber")) {
      setPhoneNumber(localStorage.getItem("phoneNumber"))
    }
  }, [])

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000)
    } else {
      // setSeconds("BOOOOM!")
      setResendEnabled(true)
    }
  }, [seconds])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  const resendOtp = async e => {
    e.preventDefault()

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_otp")
    urlencoded.append("action", "register")
    urlencoded.append("phone_number", phoneNumber)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request otp", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_AUTH,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      if (postresponse.success) {
        localStorage.setItem("OTP", JSON.stringify(postresponse))
        setOtpGet(postresponse.otp)
        setsuccess_dlg_noaction(true)
        setdynamic_title(props.t("OTP Sent"))
        setdynamic_description(postresponse.message)
        setSeconds(30)
        setResendEnabled(false)
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("OTP Sent failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [submitEnabled, setSubmitEnabled] = useState(false)

  function onOTPChange(e) {
    if (e.length == 6) {
      setSubmitEnabled(true)
      if (e == otpGet) {
        console.log("otp verification", "match")
        history.push("/set-password")
      } else {
        seterror_alert(true)
        setdynamic_title(props.t("Invalid OTP"))
        setdynamic_description(props.t("Invalid OTP"))
      }
    } else {
      setSubmitEnabled(false)
    }
    // setOtpInput(e.target.value)
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {/* <CarouselPage /> */}
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  // history.push("/verification")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{ minHeight: "100vh" }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="">
                      <Row
                        className="m-0"
                        style={{ height: "56px", backgroundColor: "#009FE2" }}
                      >
                        <Col xs={2}>
                          <Link to="/register">
                            <Button className="h-100 m-0">
                              <i className="bx bx-arrow-back align-middle font-size-20 me-2 text-white" />
                            </Button>
                          </Link>
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {props.t("Verification")}
                          </p>
                        </Col>
                        <Col xs={2}></Col>
                      </Row>
                      <div className="mx-3" style={{ marginTop: "300px" }}>
                        <Form>
                          <Row className="mb-3 px-2 justify-content-center">
                            <Label className="font-size-15 font-weight-bold">
                              {props.t("Enter your OTP (one-time password)")}
                            </Label>
                            <Col xs={12}>
                              <FormGroup className="verification d-flex justify-content-around">
                                <AuthCode
                                  characters={6}
                                  containerClassName="container"
                                  className="form-control form-control-lg text-center"
                                  allowedCharacters="^[0-9]"
                                  inputStyle={{
                                    width: "46px",
                                    height: "60px",
                                    padding: "8px",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    textAlign: "center",
                                    marginRight: "7px",
                                    marginLeft: "7px",
                                    border: "0px solid #ced4da",
                                    textTransform: "uppercase",
                                  }}
                                  onChange={onOTPChange}
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row className="mb-3 px-2">
                            <Col>
                              <Link to="/set-password">
                                <button
                                  className={
                                    submitEnabled
                                      ? "btn btn-primary btn-block waves-effect waves-light w-100 font-size-18"
                                      : "btn btn-light btn-block waves-effect waves-light w-100 font-size-18 text-muted"
                                  }
                                  type="submit"
                                  style={{ borderRadius: "8px" }}
                                  disabled={!submitEnabled}
                                >
                                  <strong>
                                    {props.t("Verify & Create Account")}
                                  </strong>
                                </button>
                              </Link>
                            </Col>
                          </Row>

                          <Row className="mb-3 px-2">
                            <p
                              className="mb-0 text-center font-size-15"
                              style={{ color: "#000000" }}
                            >
                              {props.t(
                                "Your OTP has been sent to your mobile number. Didn't receive your OTP?"
                              )}
                            </p>
                          </Row>

                          <Row className="mb-3 px-2 font-size-15">
                            <button
                              className="btn btn-link mb-0 text-center"
                              disabled={!resendEnabled}
                              onClick={resendOtp}
                            >
                              {props.t("Resend") +
                                " (" +
                                seconds +
                                " " +
                                props.t("seconds") +
                                ")"}
                            </button>
                          </Row>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Verification)

Verification.propTypes = {
  t: PropTypes.any,
}
